// extracted by mini-css-extract-plugin
export default {"link":"ActionLink_link__AvRzE","title":"ActionLink_title__b4jIc"};